module.exports = __webpack_public_path__ + "static/media/thumb_jadsprice.fe27c9af.jpeg";